import React from 'react';

import { Grid } from '@mui/material';
import { get, isEmpty, keys } from 'lodash';
import Info from './Info';

function ShipmentInfo({ data, id }) {
  if (isEmpty(data) || isEmpty(get(data, `shipments.${id}`))) return 'No data';
  const shipmentInfo = get(data, `shipments.${id}`, {});
  const deliverableAddressInfo = get(data, `deliverable_address`, {});
  const key = keys(deliverableAddressInfo)[0];
  const pins = get(deliverableAddressInfo, `${key}.pins`, []);

  return (
    <Grid container spacing={2}>
      <Info label={'Customer Profile ID'} value={get(shipmentInfo, `customer_profile_id`, '-')} />
      <Info label={'Deliverable Address ID'} value={keys(deliverableAddressInfo)?.[0]} />
      <Info
        label={'Address'}
        value={`${get(shipmentInfo, `dropoff_address.street`, '-')} - ${get(shipmentInfo, `dropoff_address.street2`, '-')}, ${get(shipmentInfo, `dropoff_address.city`, '-')},
        ${get(shipmentInfo, `dropoff_address.state`, '-')} ${get(shipmentInfo, `dropoff_address.zipcode`, '-')}`}
      />
      {!isEmpty(pins) && (
        <>
          <Grid size={12} style={{ fontWeight: '600', fontSize: 14 }}>
            Pins:
          </Grid>
          {pins?.map((pin, i) => (
            <Grid size={12} style={{ fontSize: 14, color: '#777' }} key={`pin-${i}`}>
              Pin {pin.type || i + 1}: {pin.latitude?.toFixed(6)}, {pin.longitude?.toFixed(6)}
            </Grid>
          ))}
        </>
      )}
    </Grid>
  );
}

export default ShipmentInfo;
